module.exports = __webpack_public_path__ + "img/iconSheBeiXieLiaoGuanKou.134ebab6.svg";